module.exports = __webpack_public_path__ + "a3de2170e4e9df77161ea5d3f31b2668.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./vendor/fonts/fontawesome-webfont.ttf
 ** module id = 511
 ** module chunks = 0
 **/